import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import test from "../views/EventoTest.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    // path: "/evento/:idDependencia",
  path: "/test/:id/:categoria",
  name: "TEST",
  component: function() {
    return import(/* webpackChunkName: "Evento" */ "../views/EventoTest.vue");
  }
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/About.vue");
    }
  },
  {
      // path: "/evento/:idDependencia",
    path: "/evento/:id/:categoria?",
    name: "Evento",
    component: function() {
      return import(/* webpackChunkName: "Evento" */ "../views/Evento.vue");
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
